import React from 'react';

function UnitedStates(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_123968)">
        <mask
          id="mask0_800_123968"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_123968)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H36V24H0V0Z"
            fill="#F7FCFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 14.6667V16.6667H36V14.6667H0Z"
            fill="#E31D1C"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 18.3333V20.3333H36V18.3333H0Z"
            fill="#E31D1C"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 7.33331V9.33331H36V7.33331H0Z"
            fill="#E31D1C"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 22V24H36V22H0Z"
            fill="#E31D1C"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 11V13H36V11H0Z"
            fill="#E31D1C"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V2H36V0H0Z"
            fill="#E31D1C"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 3.66669V5.66669H36V3.66669H0Z"
            fill="#E31D1C"
          />
          <rect width="22.5" height="13" fill="#2E42A5" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.93737 2.93864L1.12075 3.44753L1.39645 2.54192L0.671143 1.96801H1.61849L1.93622 1.22894L2.30879 1.96801H3.11638L2.48184 2.54192L2.7275 3.44753L1.93737 2.93864ZM6.43734 2.93864L5.62073 3.44753L5.89643 2.54192L5.17112 1.96801H6.11847L6.4362 1.22894L6.80877 1.96801H7.61636L6.98182 2.54192L7.22747 3.44753L6.43734 2.93864ZM10.1207 3.44753L10.9373 2.93864L11.7275 3.44753L11.4818 2.54192L12.1164 1.96801H11.3088L10.9362 1.22894L10.6185 1.96801H9.67112L10.3964 2.54192L10.1207 3.44753ZM15.4373 2.93864L14.6207 3.44753L14.8964 2.54192L14.1711 1.96801H15.1185L15.4362 1.22894L15.8088 1.96801H16.6164L15.9818 2.54192L16.2275 3.44753L15.4373 2.93864ZM1.12075 7.44753L1.93737 6.93864L2.7275 7.44753L2.48184 6.54192L3.11638 5.96801H2.30879L1.93622 5.22894L1.61849 5.96801H0.671143L1.39645 6.54192L1.12075 7.44753ZM6.43734 6.93864L5.62073 7.44753L5.89643 6.54192L5.17112 5.96801H6.11847L6.4362 5.22894L6.80877 5.96801H7.61636L6.98182 6.54192L7.22747 7.44753L6.43734 6.93864ZM10.1207 7.44753L10.9373 6.93864L11.7275 7.44753L11.4818 6.54192L12.1164 5.96801H11.3088L10.9362 5.22894L10.6185 5.96801H9.67112L10.3964 6.54192L10.1207 7.44753ZM15.4373 6.93864L14.6207 7.44753L14.8964 6.54192L14.1711 5.96801H15.1185L15.4362 5.22894L15.8088 5.96801H16.6164L15.9818 6.54192L16.2275 7.44753L15.4373 6.93864ZM1.12075 11.4475L1.93737 10.9386L2.7275 11.4475L2.48184 10.5419L3.11638 9.96801H2.30879L1.93622 9.22894L1.61849 9.96801H0.671143L1.39645 10.5419L1.12075 11.4475ZM6.43734 10.9386L5.62073 11.4475L5.89643 10.5419L5.17112 9.96801H6.11847L6.4362 9.22894L6.80877 9.96801H7.61636L6.98182 10.5419L7.22747 11.4475L6.43734 10.9386ZM10.1207 11.4475L10.9373 10.9386L11.7275 11.4475L11.4818 10.5419L12.1164 9.96801H11.3088L10.9362 9.22894L10.6185 9.96801H9.67112L10.3964 10.5419L10.1207 11.4475ZM15.4373 10.9386L14.6207 11.4475L14.8964 10.5419L14.1711 9.96801H15.1185L15.4362 9.22894L15.8088 9.96801H16.6164L15.9818 10.5419L16.2275 11.4475L15.4373 10.9386ZM19.1207 3.44753L19.9373 2.93864L20.7275 3.44753L20.4818 2.54192L21.1164 1.96801H20.3088L19.9362 1.22894L19.6185 1.96801H18.6711L19.3964 2.54192L19.1207 3.44753ZM19.9373 6.93864L19.1207 7.44753L19.3964 6.54192L18.6711 5.96801H19.6185L19.9362 5.22894L20.3088 5.96801H21.1164L20.4818 6.54192L20.7275 7.44753L19.9373 6.93864ZM19.1207 11.4475L19.9373 10.9386L20.7275 11.4475L20.4818 10.5419L21.1164 9.96801H20.3088L19.9362 9.22894L19.6185 9.96801H18.6711L19.3964 10.5419L19.1207 11.4475ZM4.18734 4.93864L3.37073 5.44753L3.64643 4.54192L2.92112 3.96801H3.86847L4.1862 3.22894L4.55877 3.96801H5.36636L4.73182 4.54192L4.97747 5.44753L4.18734 4.93864ZM7.87073 5.44753L8.68734 4.93864L9.47747 5.44753L9.23182 4.54192L9.86636 3.96801H9.05877L8.6862 3.22894L8.36847 3.96801H7.42112L8.14643 4.54192L7.87073 5.44753ZM13.1873 4.93864L12.3707 5.44753L12.6464 4.54192L11.9211 3.96801H12.8685L13.1862 3.22894L13.5588 3.96801H14.3664L13.7318 4.54192L13.9775 5.44753L13.1873 4.93864ZM3.37073 9.44753L4.18734 8.93864L4.97747 9.44753L4.73182 8.54192L5.36636 7.96801H4.55877L4.1862 7.22894L3.86847 7.96801H2.92112L3.64643 8.54192L3.37073 9.44753ZM8.68734 8.93864L7.87073 9.44753L8.14643 8.54192L7.42112 7.96801H8.36847L8.6862 7.22894L9.05877 7.96801H9.86636L9.23182 8.54192L9.47747 9.44753L8.68734 8.93864ZM12.3707 9.44753L13.1873 8.93864L13.9775 9.44753L13.7318 8.54192L14.3664 7.96801H13.5588L13.1862 7.22894L12.8685 7.96801H11.9211L12.6464 8.54192L12.3707 9.44753ZM17.6873 4.93864L16.8707 5.44753L17.1464 4.54192L16.4211 3.96801H17.3685L17.6862 3.22894L18.0588 3.96801H18.8664L18.2318 4.54192L18.4775 5.44753L17.6873 4.93864ZM16.8707 9.44753L17.6873 8.93864L18.4775 9.44753L18.2318 8.54192L18.8664 7.96801H18.0588L17.6862 7.22894L17.3685 7.96801H16.4211L17.1464 8.54192L16.8707 9.44753Z"
            fill="#F7FCFF"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_123968">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default UnitedStates;
